// extracted by mini-css-extract-plugin
module.exports = {"root":"header_root__kOnGh","headerTop":"header_headerTop__brXSJ","branding":"header_branding__FiY6Y"};